import { useCallback, useEffect, useState } from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import Loading from "./Loading";
import { API_BASE_URL } from "../services/api";

function anoAtual() {
  return new Date().getFullYear();
}

function anosDisponiveis() {
  const actual = anoAtual();
  return Array.from({ length: 8 }, (_, index) => actual - index);
}

function dataRecibo(data) {
  const dataTransacao = new Date(data);
  const dia = String(dataTransacao.getDate()).padStart(2, "0");
  const mes = String(dataTransacao.getMonth() + 1).padStart(2, "0");
  const ano = dataTransacao.getFullYear();

  return `${dia}/${mes}/${ano}`;
}

export default function HistoricoPagammento() {
  const [recibos, setRecibos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [anoSelecionado, setAnoSelecionado] = useState(anoAtual());
  const navigate = useNavigate();

  const mostrarRecibos = useCallback(async (ano) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const dadosRecibo = await axios.get(
        `${API_BASE_URL}/recibos?ano=${ano}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setRecibos(Array.isArray(dadosRecibo.data) ? dadosRecibo.data : []);
    } catch (erro) {
      console.log(erro);
      setRecibos([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    mostrarRecibos(anoSelecionado);
  }, [anoSelecionado, mostrarRecibos]);

  return (
    <div className="flex min-h-screen flex-col justify-between">
      <div className="sticky top-0 z-10 bg-blue-500">
        <NavBar />
      </div>

      {loading ? (
        <div className="z-0">
          <Loading />
        </div>
      ) : (
        <div className="z-0">
          <button
            className="group my-4 ml-4 md:flex lg:hidden"
            onClick={() => navigate(-1)}
          >
            <div className="flex items-center">
              <ChevronLeft className="group-hover:font-semibold" />
              <span className="ml-1 text-sm group-hover:font-semibold">
                Voltar
              </span>
            </div>
          </button>

          <div className="mx-auto m-4 mt-0 h-auto w-[95%] overflow-x-auto rounded-xl border md:my-12 md:w-[90%] lg:w-[1000px]">
            <div className="m-4 flex flex-col justify-center">
              <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="text-center text-lg text-gray-600 md:text-xl lg:text-2xl">
                  Historico de Pagamento
                </h2>
                <label className="text-sm font-semibold text-gray-600">
                  Ano
                  <select
                    value={anoSelecionado}
                    onChange={(e) => setAnoSelecionado(Number(e.target.value))}
                    className="ml-2 rounded-md border px-3 py-2"
                  >
                    {anosDisponiveis().map((ano) => (
                      <option key={ano} value={ano}>
                        {ano}
                      </option>
                    ))}
                  </select>
                </label>
              </div>

              <table className="min-w-full border border-gray-50">
                <thead>
                  <tr className="bg-gray-100 text-gray-500">
                    <th className="border px-2 py-2 text-center text-xs md:text-sm">
                      ID
                    </th>
                    <th className="border px-2 py-2 text-center text-xs md:text-sm">
                      Data
                    </th>
                    <th className="border px-2 py-2 text-center text-xs md:text-sm">
                      Metodo de Pagamento
                    </th>
                    <th className="border px-2 py-2 text-center text-xs md:text-sm">
                      Montante
                    </th>
                    <th className="border px-2 py-2 text-center text-xs md:text-sm">
                      Recibo
                    </th>
                  </tr>
                </thead>
                <tbody className="text-gray-500">
                  {recibos.map((recibo, i) => (
                    <tr key={recibo.idRecibo || i} className="border text-xs md:text-sm">
                      <td className="border px-2 py-2 text-center">{i + 1}</td>
                      <td className="border px-2 py-2 text-center">
                        {dataRecibo(recibo.dataTransacao)}
                      </td>
                      <td className="border px-2 py-2 text-center">
                        {recibo.meioPagamento}
                      </td>
                      <td className="border px-2 py-2 text-center">
                        {recibo.valor}
                      </td>
                      <td className="border px-2 py-2">
                        <button
                          type="button"
                          onClick={() => navigate(`/recibo/${recibo.idRecibo}`)}
                          className="mx-auto block text-blue-600 hover:text-blue-500"
                        >
                          Abrir
                        </button>
                      </td>
                    </tr>
                  ))}
                  {recibos.length === 0 && (
                    <tr>
                      <td
                        colSpan="5"
                        className="border px-2 py-8 text-center text-sm text-gray-500"
                      >
                        Nenhum recibo encontrado para {anoSelecionado}.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      <div className="bg-blue-500">
        <Footer />
      </div>
    </div>
  );
}
